import { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronDown, Leaf, Zap, Brain } from "lucide-react";
import solrProductImage from "@/assets/solr-focus-outdoor.jpg";

const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const scrollToProducts = () => {
    document.getElementById('shop-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const features = [
    { icon: Leaf, label: "Natural\nIngredients" },
    { icon: Zap, label: "Clean\nEnergy" },
    { icon: Brain, label: "Focus &\nClarity" },
  ];

  return (
    <section className="relative min-h-[calc(100vh-80px)] sm:min-h-screen flex items-center pt-8 sm:pt-12 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 relative z-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className={`space-y-6 text-center lg:text-left transition-all duration-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h1 className="font-display uppercase leading-[0.9] tracking-tight text-white"
                style={{ fontSize: 'clamp(3rem, 8vw, 6rem)' }}>
              Power Up
              <br />
              Naturally<span className="text-[hsl(var(--magenta-glow))]">.</span>
            </h1>

            <div className="space-y-1">
              <p className="font-display tracking-[0.18em] uppercase text-white text-sm sm:text-base">
                Natural Energy. Real Ingredients.
              </p>
              <p className="font-display tracking-[0.18em] uppercase text-[hsl(var(--magenta-glow))] text-sm sm:text-base">
                Your Best You.
              </p>
            </div>

            <div className="flex items-stretch justify-center lg:justify-start gap-6 sm:gap-8 pt-2">
              {features.map((f, i) => (
                <div key={i} className={`flex flex-col items-center gap-2 ${i < features.length - 1 ? 'pr-6 sm:pr-8 border-r border-white/10' : ''}`}>
                  <f.icon className="w-6 h-6 text-[hsl(var(--magenta-glow))]" strokeWidth={1.5} />
                  <span className="text-[10px] sm:text-xs font-display uppercase tracking-[0.16em] text-white/85 text-center whitespace-pre-line leading-tight">
                    {f.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 pt-2 justify-center lg:justify-start">
              <Link to="/shop">
                <Button className="btn-magenta w-full sm:w-auto">Shop Now</Button>
              </Link>
            </div>
          </div>

          <div className={`relative order-first lg:order-last transition-all duration-700 delay-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative flex items-center justify-center can-halo">
              <div className="relative z-10 animate-float">
                <img
                  src={solrProductImage}
                  alt="SOLR premium natural energy drink"
                  className="w-full max-w-[300px] sm:max-w-[380px] md:max-w-[440px] lg:max-w-[520px] h-auto rounded-2xl object-cover"
                  loading="eager"
                  style={{
                    maskImage: 'linear-gradient(to bottom, black 78%, transparent 100%)',
                    WebkitMaskImage: 'linear-gradient(to bottom, black 78%, transparent 100%)',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToProducts}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-1 text-white/70 hover:text-[hsl(var(--magenta-glow))] transition-colors"
        aria-label="Scroll to products"
      >
        <span className="text-[10px] font-display uppercase tracking-[0.22em]">Scroll to Explore</span>
        <ChevronDown className="w-5 h-5 animate-bounce" />
      </button>
    </section>
  );
};

export default HeroSection;
